import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { validateToken } from "../functions/validate";
import PageLoader from "./PageLoader";
import { useRedirect } from "../functions/context";
import { useConfigContext } from '../functions/ConfigContext';

import {
  SessionManager,
  sessionService,
} from '../components/ComponentsLibrary'

function Home() {
  const url = useLocation();
  const navigate = useNavigate();
  const { configLibrary } = useConfigContext();
  const [isLoading, setIsLoading] = useState(false);
  
  const { redirecting, setRedirecting, } = useRedirect();

  const getTokenFromURL2 = async () => {
    
    setIsLoading(true);
    let configData = {};
    
    if (configLibrary) {
      configData = configLibrary;
      const url = new URL(window.location.href);
      const hashParams = new URLSearchParams(url.hash.substring(1));

      const error = hashParams.get('error_description');
      const token = hashParams.get('id_token');

      if (error) {
        setRedirecting(true);
        if (error.includes("AADB2C90118")) {
          
          SessionManager.ClearSession();
          window.location.replace(configData.pwdResetUrl);
          //window.location.href = configData.pwdResetUrl;
          return;
        }
        if (error.includes("AADB2C90091")) {
         
          SessionManager.ClearSession();
          window.location.replace(configData.b2cUrl);
          //window.location.href = configData.b2cUrl;
          return;
        }
      } else if (token) {
        setRedirecting(false);
        const redirectedFrom = true;
        SessionManager.SetSession(SessionManager.RedirectedFromIDPKey, redirectedFrom);
        sessionStorage.setItem("token", token);
        //sessionStorage.setItem("REDIRECTEDFROM", redirectedFrom);
        navigate('/landing');
        return;
      }
    }

    
    setIsLoading(false);
  }


   useEffect(() => {
   
    getTokenFromURL2();  // TO-DO: Modify Code - Uncomment before Deployment
    
  }, []); 
  
  if (isLoading) {
    
    return <div>Redirecting...</div>;
  }
}

export default Home;